module.exports = __webpack_public_path__ + "product/product-step-plain-d0dc1a54739e7179971b199cdc7dad64.webp";